import DOMPurify from 'dompurify';
import {marked} from 'marked';

export function updateLeadingTextNode(element: HTMLElement, text: string): boolean {
    const firstNode = element.firstChild;
    if (firstNode?.nodeType === Node.TEXT_NODE) {
        if (firstNode.textContent === text) {
            return false;
        }
        firstNode.textContent = text;
        return true;
    }

    element.prepend(document.createTextNode(text));
    return true;
}

export function renderMarkdown(input: string): string {
    const html = marked.parse(input || '', {
        async: false,
        breaks: false,
        gfm: true,
    }) as string;

    return DOMPurify.sanitize(html, {
        ALLOWED_ATTR: ['href', 'title'],
        ALLOWED_TAGS: [
            'a',
            'blockquote',
            'br',
            'code',
            'del',
            'em',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'hr',
            'li',
            'ol',
            'p',
            'pre',
            'strong',
            'table',
            'tbody',
            'td',
            'th',
            'thead',
            'tr',
            'ul',
        ],
    });
}

export function tryParseJson(input: string): unknown {
    if (!input) {
        return null;
    }

    try {
        return JSON.parse(input);
    } catch {
        return input;
    }
}

export function formatJson(value: unknown): string {
    return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
}

export async function copyText(content: string): Promise<void> {
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(content);
        return;
    }

    const textarea = document.createElement('textarea');
    textarea.value = content;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    document.body.append(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
}
